import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPaperclip as fadPaperclip,
  faSpinnerThird as fadSpinnerThird,
} from '@fortawesome/pro-duotone-svg-icons';
import { faWhatsapp as fabWhatsApp } from '@fortawesome/free-brands-svg-icons';
import {
  faArrowDown19 as farArrowDown19,
  faArrowDown91 as farArrowDown91,
  faCalendarAlt as farCalendarAlt,
  faCheckCircle as farCheckCircle,
  faClipboardCheck as farClipboardCheck,
  faCopy as farCopy,
  faExclamationTriangle as farExclamationsTriangle,
  faExternalLink as farExternalLink,
  faHeart as farHeart,
  faInfo as farInfo,
  faPlus as farPlus,
  faStar as farStar,
  faSparkles as farSparkles,
  faUserPen as farUserPen,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faAngleDown,
  faAngleRight,
  faArrowAltCircleLeft,
  faBadgePercent,
  faBedPulse,
  faBell,
  faBriefcaseMedical,
  faBuilding,
  faCalculator,
  faCalendarAlt,
  faCar,
  faCarBurst,
  faCars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleExclamation,
  faClipboard,
  faClipboardCheck,
  faCopy,
  faDownload,
  faEnvelope,
  faExchangeAlt,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileContract,
  faFilePdf,
  faGear,
  faHandHoldingMedical,
  faHeart,
  faHospital,
  faHouseMedical,
  faInfo,
  faLink,
  faList,
  faListUl,
  faMinus,
  faMoneyBill1Wave,
  faPencil,
  faPencilAlt,
  faPersonCane,
  faPersonCirclePlus,
  faPlaneDeparture,
  faPlus,
  faPrint,
  faRedo,
  faSave,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faStamp,
  faStar,
  faStarHalfAlt,
  faSync,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTooth,
  faTrash,
  faTrashAlt,
  faUser,
  faUserGroup,
  faFlagCheckered,
  faClipboardListCheck,
  faUpload,
  faFileImport,
  faSparkles,
  faShieldAlt,
  faHomeLg,
} from '@fortawesome/pro-solid-svg-icons';

// solid icons
library.add(
  faAngleDown,
  faAngleRight,
  faArrowAltCircleLeft,
  faBadgePercent,
  faBell,
  faBuilding,
  faCalendarAlt,
  faCar,
  faCarBurst,
  faCars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleExclamation,
  faDownload,
  faEnvelope,
  faExchangeAlt,
  faExclamationTriangle,
  faEye,
  faFile,
  faFilePdf,
  faGear,
  faHeart,
  faInfo,
  faList,
  faListUl,
  faMinus,
  faPencil,
  faPencilAlt,
  faPersonCirclePlus,
  faPlus,
  faPrint,
  faSave,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faStamp,
  faSync,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrash,
  faTrashAlt,
  faUser,
  faUserGroup,
  faRedo,
  faClipboard,
  faClipboardCheck,
  faCalculator,
  faFileContract,
  faStar,
  faStarHalfAlt,
  faHospital,
  faBedPulse,
  faHouseMedical,
  faPlaneDeparture,
  faMoneyBill1Wave,
  faPersonCane,
  faHandHoldingMedical,
  faBriefcaseMedical,
  faTooth,
  faCopy,
  faLink,
  faFlagCheckered,
  faClipboardListCheck,
  faUpload,
  faFileImport,
  faSparkles,
  faShieldAlt,
  faHomeLg,
);

// regular icons
library.add(
  farCheckCircle,
  farExclamationsTriangle,
  farHeart,
  farInfo,
  farPlus,
  farCalendarAlt,
  farArrowDown19,
  farArrowDown91,
  farStar,
  farCopy,
  farClipboardCheck,
  farExternalLink,
  farSparkles,
  farUserPen,
);

// duo tone icons
library.add(fadSpinnerThird, fadPaperclip);

// brand icons
library.add(fabWhatsApp);
